$(document).ready(function () {

      var currentSelectedLang = $('.wgcurrent.wg-li.wg-flags.flag-1').data('l');
        if(typeof currentSelectedLang == "undefined"){
        currentSelectedLang = "en";
    }

    resetPassword(currentSelectedLang);
  
        Weglot.on("languageChanged", function(newLang, prevLang) {
            resetPassword(newLang);
        });


   

  function resetPassword(currentSelectedLang){
     if($(".reset-form").length > 0){
        if(currentSelectedLang == 'en'){
          var str1 = $(".reset-form p.reset-pwd-msg").text();
            var str2 = "為以下帳號輸入一組新的密碼";
            if(str1.indexOf(str2) != -1){
                var str3 = str1.split(str2);
                var newStr = "Enter a new password for "+ str3[1];
            $(".reset-form p.reset-pwd-msg").text(newStr)
            }
        } else{
            var str1 = $(".reset-form p.reset-pwd-msg").text();
            var str2 = "Enter a new password for";
            if(str1.indexOf(str2) != -1){
                var str3 = str1.split(str2);
                var newStr = "為以下帳號輸入一組新的密碼 "+ str3[1];
                $(".reset-form p.reset-pwd-msg").text(newStr)
            }
        
        }
    }
  }
  
    
  });